import {ActivatedRouteSnapshot, Resolve} from '@angular/router';
import {Injectable} from '@angular/core';
import {AppointmentService} from "../services/appointment.service";
import {Observable} from "rxjs";
import {FactoryIdToCountryMapper} from "../services/factory-id-to-country-mapper";
import {SettingsService} from "../services/settings.service";

@Injectable()
export class SettingsResolver implements Resolve<any> {
  constructor(
    private settingsService: SettingsService,
    private factoryIdToCountryMapper: FactoryIdToCountryMapper,
  ) {
  }

  public resolve(route: ActivatedRouteSnapshot): Observable<any> {
    const country = this.factoryIdToCountryMapper.getCountry(route.params['factoryId']) || 'DE';
    console.log("Resolving settings for factoryId: " + route.params['factoryId'] + " and country: " + country);
    return this.settingsService.getSettings(country);
  }
}
